import React from 'react';
import { useSelector } from 'react-redux';

const Footer = () => {
    const state = useSelector(state=> state)
    console.log(state)
    return (
        <footer>
            <div>Logo</div>    
            <div className="section-footer">
                <ul>
                    <li>Este </li>
                    <li>este </li>
                    <li>este </li>
                </ul>
                <ul>
                    <li>este </li>
                    <li>este </li>
                    <li>este</li>
                </ul>
            </div>  
        </footer>
    );
};

export default Footer;